import { render } from "./testeBootstrap.vue?vue&type=template&id=83bf80ae"
import script from "./testeBootstrap.vue?vue&type=script&lang=js"
export * from "./testeBootstrap.vue?vue&type=script&lang=js"

import "./testeBootstrap.vue?vue&type=style&index=0&id=83bf80ae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__